<template>
  <div
    class="d-flex jc-center ai-center h-100 p-relative min-height overflow-y-overlay"
  >
    <div class="d-flex profile-main">
      <div class="d-flex flex-column ai-center menu">
        <router-link
          active-class="active"
          :class="{ active: isProfile }"
          exact
          tag="a"
          :to="`/${this.$i18n.locale}/profile`"
        >
          {{ $t("nav.accountData") }}
        </router-link>
        <router-link
          class="mt-4"
          active-class="active"
          tag="a"
          :to="`/${this.$i18n.locale}/profile/resetpassword`"
        >
          {{ $t("nav.resetPassword") }}
        </router-link>
        <router-link
          class="mt-4"
          active-class="active"
          tag="a"
          :to="`/${this.$i18n.locale}/profile/order`"
        >
          {{ $t("nav.orderInquire") }}
        </router-link>
      </div>
      <div class="d-flex flex-column flex-1 h-100">
        <div class="subheader">{{ $t("profile.welcome") }} {{ name }}</div>
        <router-view class="profile content"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  computed: {
    name() {
      return this.$store.state.user.name;
    },
    isProfile() {
      return this.$route.path.includes("edit");
    }
  },
  methods: {
    ...mapMutations("header", ["setHeaderAttr"])
  },
  created() {
    this.setHeaderAttr({ background: "default", fixedTop: false });
    this.$vuetify.theme.dark = false;
  }
};
</script>

<style lang="sass" scoped>
.min-height
  min-height: 32rem
.profile-main
  position: absolute
  width: 54rem
  min-height: 30rem
  height: 85%
  border-radius: 1rem
  background: white
  overflow: hidden
  .subheader
    margin: 2.25rem
    margin-bottom: 1.8rem
    font-size: 1.25rem
    font-weight: bold
  .content
    position: relative
    font-size: 0.85rem
    overflow-y: overlay
  .menu
    background: #181C24
    width: 11rem
    padding-top: 5rem
    a
      user-select: none
      color: white
      &:hover
        color: #ffffffcc
      &.active
        color: #ffa20a
</style>
